import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const generateConversationId = () => crypto.randomUUID();

type UseConversationOptions = {
  generateIfNotDefined: boolean;
};

export function useConversationId(
  { generateIfNotDefined }: UseConversationOptions = { generateIfNotDefined: false }
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentConversationQueryParam = searchParams.get('conversation');
  const currentConversationId =
    currentConversationQueryParam || (generateIfNotDefined ? generateConversationId() : null);

  const setConversationId = useCallback(
    (conversationId: string) => {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.set('conversation', conversationId);
        return newParams;
      });
    },
    [setSearchParams]
  );

  useEffect(() => {
    if (currentConversationId && currentConversationQueryParam !== currentConversationId) {
      setConversationId(currentConversationId);
    }
  }, [currentConversationId, currentConversationQueryParam, setConversationId]);

  const handleNewConversation = (): string => {
    const newConversationId = generateConversationId();
    setConversationId(newConversationId);

    return newConversationId;
  };

  return {
    currentConversationId: currentConversationId,
    generateConversationId,
    handleNewConversation,
    setConversationId,
  };
}
